var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormProvider } from 'react-hook-form';
import { FormTextarea, FormControl } from 'shared/components';
import { Box, Heading, Text } from 'shared/components/ui';
import { SignAppendConfirm } from './signAppendConfirm';
export var AppendForm = function (_a) {
    var member = _a.member, appendMode = _a.appendMode, appendConfirmed = _a.appendConfirmed, appendConfirmDisclosure = _a.appendConfirmDisclosure, form = _a.form, visible = _a.visible;
    if (!visible)
        return null;
    return (_jsxs(_Fragment, { children: [_jsxs(Heading, __assign({ "data-testid": "appendNote-header", size: "h3", mb: 2 }, { children: ["Information Appended to Note", ' ', appendMode === 1 /* NoteAppendMode.create */ && (_jsx(Text, __assign({ as: "span", color: 'green.600' }, { children: "*" })))] })), appendMode === 1 /* NoteAppendMode.create */ && (_jsxs(FormProvider, __assign({}, form, { children: [_jsx(Box, __assign({ pl: 4, mb: 3 }, { children: _jsx(FormControl, __assign({ isRequired: true }, { children: _jsx(FormTextarea, { "data-testid": "appendment", name: "appendment", displayErrors: true, register: form.register, rules: { required: 'Please enter text to finish appending this note' }, errors: form.formState.errors }) })) })), _jsx(SignAppendConfirm, { member: member, disclosure: appendConfirmDisclosure, onConfirm: appendConfirmed })] })))] }));
};
